export default __webpack_public_path__ + "static/media/generalSupplies.669c9e9a.png";